<template>
  <v-container v-show="$auth.ready()" >
    <h2 class="mt-5">User Profile</h2>
    <v-simple-table>
      <template v-slot:default>
        <tbody>
          <tr><td>Full name</td><td>{{ user.fullName }}</td></tr>
          <tr><td>Username</td><td>{{ user.username }}</td></tr>
          <tr><td>Boat name</td><td>{{ user.boatName }}</td></tr>
          <tr><td>Email</td><td>{{ user.email }}</td></tr>
          <tr><td>Country</td><td><vue-country-code style="margin-right: 10px;" :disabledFetchingCountry=true :defaultCountry="user.country" @onSelect="editCountry" />({{ countryName }})</td></tr>
          <tr><td>Language</td><td>{{ user.locale }}</td></tr>
          <tr><td>Role</td><td>{{ user.role }}</td></tr>
          <tr><td>Racepoints</td><td>{{ user.racePoints }}</td></tr>
          <tr><td>eSail Version</td><td>{{ user.esailVersion }}</td></tr>
        </tbody>
      </template>
    </v-simple-table>
    <h2 class="mt-10">Notification Settings</h2>
    <v-simple-table>
      <template v-slot:default>
        <tbody>
        <tr><td>Receive General Notifications</td><td><v-switch v-model="user.receiveGeneralNotifications" @change="updateNotificationOptions"/></td></tr>
        <tr><td>Receive Challenge Notifications</td><td><v-switch v-model="user.receiveChallengeNotifications" @change="updateNotificationOptions"/></td></tr>
        </tbody>
      </template>
    </v-simple-table>
    <br>
    <v-btn block @click="logout">Logout</v-btn>
  </v-container>
</template>

<script>

import {eSailServerAuth} from "@/plugins/axios";

export default {
  name: "UserProfileView",
  data: () => ({
    user: {},
    countryName: ''
  }),
  mounted() {
    this.user = this.$auth.user()
  },
  methods: {
    logout() {
      this.$auth.logout({ makeRequest: false})
    },
    updateNotificationOptions() {
      eSailServerAuth.put('users/current/notifications', this.user, { headers: { Authorization: `Bearer ` + this.$auth.token() }})
    },
    editCountry({iso2, name}) {
      this.countryName = name
      if (this.user.country && iso2 !== this.user.country) {
        this.user.country = iso2
        eSailServerAuth.put('users/current', this.user, { headers: { Authorization: `Bearer ` + this.$auth.token() }})
      }
    }
  }
}
</script>

<style scoped>

</style>